import React, {useCallback, useMemo, useState} from "react"

import {useAccommodationsPage} from "../../../AccommodationContext";
import {useApartment} from "../ApartmentContext";
import {useFeedbackTools} from "../../../../../components/FeedbackTools";
import ServiceList, {serviceState} from "../../../ServiceList";

import ListItemIcon from "@mui/material/ListItemIcon";
import CountertopsIcon from '@mui/icons-material/Countertops';
import BathtubIcon from '@mui/icons-material/Bathtub';
import BedIcon from '@mui/icons-material/Bed';
import CribIcon from '@mui/icons-material/Crib';
import AddIcon from '@mui/icons-material/Add';
import {ListItem, ListItemText} from "@mui/material";


const groups = {
    kitchen: {name: "Cucina", order: 0, icon: <CountertopsIcon color="primary"/>},
    bathroom: {name: "Bagno", order: 1, icon: <BathtubIcon color="primary"/>},
    bedroom: {name: "Camera da letto", order: 2, icon: <BedIcon color="primary"/>},
    kids: {name: "Accessori bambini", order: 3, icon: <CribIcon color="primary"/>},
    default: {name: "Altro", order: 4, icon: <AddIcon color="primary"/>}
}

const sortGroups = (groupA, groupB) => {
    return groups[groupA].order - groups[groupB].order;
}

const renderGroup = (group) => {
    return <ListItem sx={{px: 2, pt: 2}}>
        <ListItemIcon>
            {groups[group].icon}
        </ListItemIcon>
        <ListItemText primaryTypographyProps={{variant: "subtitle2", color: "primary"}}>
            {groups[group].name}
        </ListItemText>
    </ListItem>
}

const ApartmentServices = () => {
    const {apartmentServices: allServices} = useAccommodationsPage();
    const {serviceJoins, updateApartmentServiceJoins} = useApartment();
    const [isLoading, setIsLoading] = useState(false);
    const {showErrorNotification, showSuccessNotification} = useFeedbackTools();

    const services = useMemo(
        () => allServices.map(({id, nameIt, group}) => {
            const selected = serviceJoins.find(s => s.apartmentServiceId === id);
            return {
                id: id,  // id of the home service
                name: nameIt,  // Name of the apartment service
                group: group,  // Group of the apartment service
                apartmentServiceJoinId: selected ? selected.id : null,
            }
        }),
        [allServices, serviceJoins]
    )

    const getServiceState = useCallback(
        (service) => {
            const selected = serviceJoins.find(s => s.apartmentServiceId === service.id);
            return selected ? (selected.withFee ? serviceState.withFee : serviceState.present) : serviceState.absent;
        },
        [serviceJoins]
    )

    const handleSave = async (services) => {
        const newServiceJoinsList = services
            .filter(s => s.state !== serviceState.absent)
            .map(s => ({
                id: s.apartmentServiceJoinId,
                apartmentServiceId: s.id,
                withFee: s.state === serviceState.withFee,
            }))

        setIsLoading(true);
        try {
            await updateApartmentServiceJoins(newServiceJoinsList);
            showSuccessNotification("Salvataggio completato");
        } catch (e) {
            showErrorNotification(e);
        }
        setIsLoading(false);
    }

    return <ServiceList services={services}
                        onSave={handleSave}
                        getServiceState={getServiceState}
                        renderGroup={renderGroup}
                        sortGroups={sortGroups}
                        isLoading={isLoading}/>
}

export default ApartmentServices;